import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import HailIcon from '@mui/icons-material/Hail';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import BuildIcon from '@mui/icons-material/Build';
import Groups2Icon from '@mui/icons-material/Groups2';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
//subcatalogo
import BrandingWatermarkIcon from '@mui/icons-material/BrandingWatermark';
import CarCrashIcon from '@mui/icons-material/CarCrash';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import EngineeringIcon from '@mui/icons-material/Engineering';
import AirlineSeatReclineNormalIcon from '@mui/icons-material/AirlineSeatReclineNormal';
import ReduceCapacityIcon from '@mui/icons-material/ReduceCapacity';
import SwitchAccountIcon from '@mui/icons-material/SwitchAccount';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
//imagenes
import ForkLeftIcon from '@mui/icons-material/ForkLeft';
import ContentPasteGoIcon from '@mui/icons-material/ContentPasteGo';
import FeedIcon from '@mui/icons-material/Feed';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import KitchenIcon from '@mui/icons-material/Kitchen';
import CommuteIcon from '@mui/icons-material/Commute';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import DiscountIcon from '@mui/icons-material/Discount';
import PercentIcon from '@mui/icons-material/Percent';
import StoreIcon from '@mui/icons-material/Store';
import StorefrontIcon from '@mui/icons-material/Storefront';
import RoomIcon from '@mui/icons-material/Room';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';

export const data = [
    {
        id: 108,
        name: 'FACTURAS',
        icon: <LibraryBooksIcon className='icon' style={{color: "white"}}/>,
        restriccion:"",
        sections: [
 
          {
            id: 108101,
            name: "CONCEPTOS",
            icon: <CreditScoreIcon className='icon' style={{color: "white"}}/>,
            permision: [' '],
            videos: [
              {
                code: 1081011,
                titlevideo: "MANUAL DE CONCEPTOS", 
                description: 'MANUAL DE CONCEPTOS', 
                url: 'https://documentacion-od2-etal.s3.amazonaws.com/FACTURAS/_Manual+Conceptos.pdf', 
                img: 'https://documentacion-od2-etal.s3.amazonaws.com/FACTURAS/conceptos.png',
              }
            ]
          },
          {
            id: 108102,
            name: "CONSULTAR FACTURAS",
            icon: <RequestQuoteIcon className='icon' style={{color: "white"}}/>,
            permision: [' '],
            videos: [
              {
                code: 1081021,
                titlevideo: "MANUAL DE FACTURAS", 
                description: 'MANUAL DE FACTURAS', 
                url: 'https://documentacion-od2-etal.s3.amazonaws.com/FACTURAS/Manual+Consultar+Facturas.pdf', 
                img: 'https://documentacion-od2-etal.s3.amazonaws.com/FACTURAS/facturas.png',
              }
            ]
          },
          {
            id: 108103,
            name: "CONSULTAR FACTURAS PPD",
            icon: <RequestQuoteIcon className='icon' style={{color: "white"}}/>,
            permision: [' '],
            videos: [
              {
                code: 1081031,
                titlevideo: "MANUAL DE FACTURAS PPD", 
                description: 'MANUAL DE FACTURAS PPD', 
                url: 'https://documentacion-od2-etal.s3.amazonaws.com/FACTURAS/Manual+Consultar+Facturas+PPD.pdf', 
                img: 'https://documentacion-od2-etal.s3.amazonaws.com/FACTURAS/facturas+ppd.png',
              }
            ]
          },
          {
            id: 108104,
            name: "IMPUESTOS",
            icon: <MoneyOffIcon className='icon' style={{color: "white"}}/>,
            permision: [' '],
            videos: [
              {
                code: 1081041,
                titlevideo: "MANUAL DE IMPUESTOS", 
                description: 'MANUAL DE IMPUESTOS', 
                url: 'https://documentacion-od2-etal.s3.amazonaws.com/FACTURAS/Manual+Impuestos.pdf', 
                img: 'https://documentacion-od2-etal.s3.amazonaws.com/FACTURAS/impuestos.png',
              }
            ]
          },
        
          {
            id: 108106,
            name: "REALIZAR FACTURA",
            icon: <FeedIcon className='icon' style={{color: "white"}}/>,
            permision: [' '],
            videos: [
              {
                code: 1081061,
                titlevideo: "REALIZAR FACTURA", 
                description: 'REALIZAR FACTURA', 
                url: 'https://documentacion-od2-etal.s3.amazonaws.com/FACTURAS/Realizar+Factura.pdf', 
                img: 'https://documentacion-od2-etal.s3.amazonaws.com/FACTURAS/realizar+factura.png',
              }
            ]
          },
         
        ]
    },
    {
         id: 108,
         name: 'SOCIOS DE NEGOCIOS',
         icon: <Groups2Icon className='icon' style={{color: "white"}}/>,
         restriccion:"",
         sections: [
          
          {
            id: 108104,
            name: 'SOCIOS DE NEGOCIOS',
            icon: <SwitchAccountIcon className='icon' style={{color: "white"}}/>,
            permision: [' '],
            videos: [
              {
               code: 1081041,
                titlevideo: "MANUAL SOCIOS DE NEGOCIOS", 
                description: 'MANUAL SOCIOS DE NEGOCIOS', 
                url: 'https://documentacion-od2-etal.s3.amazonaws.com/SOCIO+DE+NEGOCIOS/Socios+de+Negocios.pdf', 
                img: 'https://documentacion-od2-etal.s3.amazonaws.com/SOCIO+DE+NEGOCIOS/socios+de+negocios.png',
              }
            ]
          },
          ]
        },
       
    {
      id: 111,
      name: 'SOPORTES',
      icon: <SupportAgentIcon className='icon' style={{color: "white"}}/>,
      restriccion:"",
      sections: [

        {
          id: 110101,
          name: "CENTRO DE AYUDA",
          icon: <LocalActivityIcon className='icon' style={{color: "white"}}/>,
          permision: [' '],
          videos: [
            {
              code: 1101011,
              titlevideo: "MANUAL DE CENTRO DE AYUDA", 
              description: 'MANUAL DE CENTRO DE AYUDA', 
              url: 'https://documentacion-od2-etal.s3.amazonaws.com/SOPORTES/Manual+Centro+de+Ayuda.pdf', 
              img: 'https://documentacion-od2-etal.s3.amazonaws.com/SOPORTES/CENTRO+DE+AYUDA.png',
            }
          ]
        },
      ]
  }
]